/* Pet Nugget dog age calculator: breed data. GENERATED FILE, do not edit by hand.
 * Median lifespans: McMillan et al. 2024, Scientific Reports 14:531 (UK, 584,734 dogs).
 * n = display name, l = median lifespan in years, s = weight class by typical adult weight
 * (small up to 20 lb, medium 21 to 50, large 51 to 100, giant over 100; null = ask for size),
 * low = small sample in the study (under 200 dogs, or no upper confidence bound).
 * Weight classes: from the breed-standard override file. */
(function (host) {
  'use strict';
  var data = {
    breeds: [
      { n: "Affenpinscher", l: 9.3, s: "small", low: false },
      { n: "Afghan Hound", l: 11.1, s: "large", low: false },
      { n: "Airedale Terrier", l: 12, s: "large", low: false },
      { n: "Akita", l: 11.4, s: "large", low: false },
      { n: "Alaskan Malamute", l: 11.3, s: "large", low: false },
      { n: "American Cocker Spaniel", l: 13.3, s: "medium", low: false },
      { n: "American Eskimo Dog", l: 11.3, s: null, low: true },
      { n: "American Staffordshire Terrier", l: 12.5, s: "large", low: true },
      { n: "Anatolian Shepherd", l: 10.1, s: "giant", low: true },
      { n: "Australian Cattle Dog", l: 14, s: "medium", low: true },
      { n: "Australian Kelpie", l: 12, s: "medium", low: true },
      { n: "Australian Shepherd", l: 13.7, s: "large", low: false },
      { n: "Basenji", l: 12.1, s: "medium", low: true },
      { n: "Basset Hound", l: 12.5, s: "large", low: false },
      { n: "Beagle", l: 12.5, s: "medium", low: false },
      { n: "Bearded Collie", l: 13.9, s: "medium", low: false },
      { n: "Bedlington Terrier", l: 13.7, s: "small", low: false },
      { n: "Belgian Malinois", l: 12, s: "large", low: false },
      { n: "Belgian Tervuren", l: 13.8, s: "large", low: false },
      { n: "Bernese Mountain Dog", l: 10.1, s: "large", low: false },
      { n: "Bichon Frise", l: 12.5, s: "small", low: false },
      { n: "Black Russian Terrier", l: 10.9, s: "giant", low: true },
      { n: "Bloodhound", l: 9.3, s: "large", low: true },
      { n: "Bolognese", l: 14.9, s: "small", low: true },
      { n: "Border Collie", l: 13.1, s: "medium", low: false },
      { n: "Border Terrier", l: 14.2, s: "small", low: false },
      { n: "Borzoi", l: 12, s: "large", low: true },
      { n: "Boston Terrier", l: 11.8, s: "small", low: false },
      { n: "Bouvier des Flandres", l: 11.3, s: "large", low: true },
      { n: "Boxer", l: 11.3, s: "large", low: false },
      { n: "Bracco Italiano", l: 13.8, s: "large", low: true },
      { n: "Briard", l: 12.6, s: "large", low: false },
      { n: "Brittany", l: 11.1, s: "medium", low: false },
      { n: "Brussels Griffon", l: 13.3, s: "small", low: false },
      { n: "Bull Terrier", l: 12, s: "large", low: false },
      { n: "Bulldog", l: 9.8, s: "medium", low: false },
      { n: "Bullmastiff", l: 10.2, s: "giant", low: false },
      { n: "Cairn Terrier", l: 14, s: "small", low: false },
      { n: "Canaan Dog", l: 12, s: "medium", low: true },
      { n: "Cane Corso", l: 8.1, s: "large", low: false },
      { n: "Cardigan Welsh Corgi", l: 13.1, s: "medium", low: false },
      { n: "Caucasian Shepherd Dog", l: 5.4, s: "giant", low: true },
      { n: "Cavalier King Charles Spaniel", l: 11.8, s: "small", low: false },
      { n: "Chesapeake Bay Retriever", l: 11.6, s: "large", low: true },
      { n: "Chihuahua", l: 11.8, s: "small", low: false },
      { n: "Chinese Crested", l: 13.4, s: "small", low: false },
      { n: "Chinese Shar-Pei", l: 10.6, s: "large", low: false },
      { n: "Chow Chow", l: 12.1, s: "large", low: false },
      { n: "Clumber Spaniel", l: 12.3, s: "large", low: false },
      { n: "Collie (Rough)", l: 13.3, s: "large", low: false },
      { n: "Coton de Tulear", l: 14.2, s: "small", low: true },
      { n: "Curly-Coated Retriever", l: 12.2, s: "large", low: true },
      { n: "Dachshund (Standard)", l: 13.2, s: "medium", low: false },
      { n: "Dalmatian", l: 13.2, s: "large", low: false },
      { n: "Dandie Dinmont Terrier", l: 12.8, s: "medium", low: true },
      { n: "Doberman Pinscher", l: 11.2, s: "large", low: false },
      { n: "Dogue de Bordeaux", l: 11.1, s: "giant", low: false },
      { n: "English Cocker Spaniel", l: 13.3, s: "medium", low: false },
      { n: "English Foxhound", l: 13, s: "large", low: true },
      { n: "English Setter", l: 13.1, s: "large", low: false },
      { n: "English Springer Spaniel", l: 13.5, s: "medium", low: false },
      { n: "Field Spaniel", l: 13.1, s: "medium", low: false },
      { n: "Finnish Lapphund", l: 13.8, s: "medium", low: true },
      { n: "Flat-Coated Retriever", l: 11.7, s: "large", low: false },
      { n: "French Bulldog", l: 9.8, s: "medium", low: false },
      { n: "German Shepherd", l: 11.3, s: "large", low: false },
      { n: "German Shorthaired Pointer", l: 13.4, s: "large", low: false },
      { n: "German Spitz (Mittel)", l: 14, s: "medium", low: false },
      { n: "German Wirehaired Pointer", l: 13, s: "large", low: false },
      { n: "Giant Schnauzer", l: 12.1, s: "large", low: false },
      { n: "Glen of Imaal Terrier", l: 12.1, s: "medium", low: true },
      { n: "Golden Retriever", l: 13.2, s: "large", low: false },
      { n: "Gordon Setter", l: 12.4, s: "large", low: false },
      { n: "Great Dane", l: 10.6, s: "giant", low: false },
      { n: "Great Pyrenees", l: 10.9, s: "giant", low: false },
      { n: "Greyhound", l: 11.5, s: "large", low: false },
      { n: "Havanese", l: 14.5, s: "small", low: true },
      { n: "Irish Setter", l: 12.9, s: "large", low: false },
      { n: "Irish Terrier", l: 13.5, s: "medium", low: false },
      { n: "Irish Water Spaniel", l: 10.8, s: "large", low: true },
      { n: "Irish Wolfhound", l: 9.9, s: "giant", low: false },
      { n: "Italian Greyhound", l: 14, s: "small", low: false },
      { n: "Jack Russell Terrier", l: 13.3, s: "small", low: false },
      { n: "Japanese Chin", l: 12.5, s: "small", low: false },
      { n: "Japanese Spitz", l: 13, s: "small", low: false },
      { n: "Keeshond", l: 12.3, s: "medium", low: true },
      { n: "Kerry Blue Terrier", l: 12.4, s: "medium", low: false },
      { n: "Labrador Retriever", l: 13.1, s: "large", low: false },
      { n: "Lakeland Terrier", l: 14.2, s: "small", low: false },
      { n: "Lancashire Heeler", l: 15.4, s: "small", low: false },
      { n: "Large Munsterlander", l: 14.1, s: "large", low: true },
      { n: "Leonberger", l: 10, s: "giant", low: false },
      { n: "Lhasa Apso", l: 14, s: "small", low: false },
      { n: "L\u00f6wchen", l: 13.9, s: "small", low: true },
      { n: "Maltese", l: 13.1, s: "small", low: false },
      { n: "Mastiff", l: 9, s: "giant", low: false },
      { n: "Miniature Bull Terrier", l: 12.2, s: "medium", low: false },
      { n: "Miniature Dachshund", l: 14, s: "small", low: false },
      { n: "Miniature Pinscher", l: 13.7, s: "small", low: false },
      { n: "Miniature Schnauzer", l: 13.3, s: "small", low: false },
      { n: "Neapolitan Mastiff", l: 9.3, s: "giant", low: false },
      { n: "Newfoundland", l: 11, s: "giant", low: false },
      { n: "Norfolk Terrier", l: 13.5, s: "small", low: false },
      { n: "Norwegian Elkhound", l: 12.9, s: "large", low: true },
      { n: "Norwich Terrier", l: 14, s: "small", low: true },
      { n: "Nova Scotia Duck Tolling Retriever", l: 13.2, s: "medium", low: true },
      { n: "Old English Sheepdog", l: 12.1, s: "large", low: false },
      { n: "Papillon", l: 14.5, s: "small", low: false },
      { n: "Parson Russell Terrier", l: 13.8, s: "small", low: false },
      { n: "Pekingese", l: 13.3, s: "small", low: false },
      { n: "Pembroke Welsh Corgi", l: 13.2, s: "medium", low: false },
      { n: "Petit Basset Griffon Vend\u00e9en", l: 13.7, s: "medium", low: false },
      { n: "Pharaoh Hound", l: 10, s: "medium", low: true },
      { n: "Polish Lowland Sheepdog", l: 13.2, s: "medium", low: true },
      { n: "Pomeranian", l: 12.2, s: "small", low: false },
      { n: "Poodle (any size)", l: 14, s: null, low: false },
      { n: "Portuguese Water Dog", l: 13, s: "medium", low: true },
      { n: "Presa Canario", l: 7.7, s: "large", low: true },
      { n: "Pug", l: 11.6, s: "small", low: false },
      { n: "Puli", l: 13.3, s: "medium", low: true },
      { n: "Rhodesian Ridgeback", l: 12, s: "large", low: false },
      { n: "Rottweiler", l: 10.6, s: "large", low: false },
      { n: "Saluki", l: 13.3, s: "large", low: false },
      { n: "Samoyed", l: 13.1, s: "medium", low: false },
      { n: "Schipperke", l: 14.2, s: "small", low: true },
      { n: "Scottish Deerhound", l: 10.5, s: "large", low: false },
      { n: "Scottish Terrier", l: 12.7, s: "small", low: false },
      { n: "Sealyham Terrier", l: 13.1, s: "medium", low: true },
      { n: "Shetland Sheepdog", l: 13.4, s: "small", low: false },
      { n: "Shiba Inu", l: 14.6, s: "small", low: false },
      { n: "Shih Tzu", l: 12.8, s: "small", low: false },
      { n: "Siberian Husky", l: 11.9, s: "medium", low: false },
      { n: "Silky Terrier", l: 13.3, s: "small", low: true },
      { n: "Skye Terrier", l: 12.4, s: "medium", low: true },
      { n: "Soft Coated Wheaten Terrier", l: 13.7, s: "medium", low: false },
      { n: "Spanish Water Dog", l: 13.7, s: "medium", low: true },
      { n: "Spinone Italiano", l: 11.9, s: "large", low: false },
      { n: "St. Bernard", l: 9.3, s: "giant", low: false },
      { n: "Staffordshire Bull Terrier", l: 12, s: "medium", low: false },
      { n: "Standard Schnauzer", l: 13, s: "medium", low: false },
      { n: "Sussex Spaniel", l: 13.5, s: "medium", low: true },
      { n: "Swedish Vallhund", l: 14, s: "medium", low: true },
      { n: "Tibetan Mastiff", l: 13.3, s: "giant", low: true },
      { n: "Tibetan Spaniel", l: 15.2, s: "small", low: false },
      { n: "Tibetan Terrier", l: 13.8, s: "medium", low: false },
      { n: "Toy Fox Terrier", l: 12.9, s: "small", low: true },
      { n: "Toy Manchester Terrier", l: 13, s: "small", low: false },
      { n: "Vizsla", l: 13.5, s: "large", low: false },
      { n: "Weimaraner", l: 12.8, s: "large", low: false },
      { n: "Welsh Springer Spaniel", l: 14, s: "medium", low: false },
      { n: "Welsh Terrier", l: 13.8, s: "small", low: false },
      { n: "West Highland White Terrier", l: 13.4, s: "small", low: false },
      { n: "Whippet", l: 13.4, s: "medium", low: false },
      { n: "Wire Fox Terrier", l: 13.5, s: "small", low: false },
      { n: "Yorkshire Terrier", l: 13.3, s: "small", low: false }
    ],
    mixedMedian: 12,
    mixedBySize: { small: 12, medium: 12, large: 12, giant: 10.1 },
    study: { dogs: 584734, breeds: 155, label: "a 2024 UK study of 584,734 dogs" }
  };
  if (typeof module === 'object' && module.exports) module.exports = data;
  if (host) host.PNDogAgeData = data;
})(typeof window !== 'undefined' ? window : null);
